import React, { useEffect, useState } from 'react'
import DormantBpModal from 'components/atoms/DormantBpModal'
import { getSubscriptionPaymentStatus } from 'services/billingService'

const PastDueSubscriptionAlert = ({ enabled }) => {
  const [checked, setChecked] = useState(false)
  const [buildingPassports, setBuildingPassports] = useState([])
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setChecked(false)
      setOpen(false)
      return
    }

    if (checked) return

    setChecked(true)
    getSubscriptionPaymentStatus()
      .then(response => {
        const data = response?.data?.data || {}
        const affected = data.buildingPassports || []

        setBuildingPassports(affected)
        setOpen(Boolean(data.paymentRequired && affected.length))
      })
      .catch(() => {
        // Access enforcement is server-side; a temporary status-check failure
        // must not break the rest of the application.
      })
  }, [enabled, checked])

  const first = buildingPassports[0]
  const displayName = buildingPassports.length > 1
    ? `${buildingPassports.length} Building Passports`
    : first?.name

  return (
    <DormantBpModal
      open={open}
      onClose={() => setOpen(false)}
      bpId={first?.id}
      bpName={displayName}
      paymentPastDue
      canResolvePayment
    />
  )
}

export default PastDueSubscriptionAlert
